export default [
  {
    path: '/index',
    name: 'index',
    meta: {
      title: '文化旅游云'
    },
    component: () => import('@/pages/index/index.vue'),
  },
  {
    path: '',
    name: 'index',
    meta: {
      title: '文化旅游云'
    },
    component: () => import('@/pages/index/index.vue'),
  }
]